export default __webpack_public_path__ + "static/media/13.7964b8a1.jpg";